// =============================================================================
// ui/shell/DemoBanner.tsx — whose data am I looking at?
// -----------------------------------------------------------------------------
// Relocated from the old client's `refreshDemoBanner` (app/index.html:8414).
//
// ── 🚨 IT IS THE ONLY WAY OUT, SO IT CANNOT BE DISMISSED AND CANNOT SCROLL AWAY ──
//
// The old client's comment says it plainly: this renders on EVERY tab, and it
// answers the one question a swapped-out dataset makes genuinely ambiguous. A
// dismissible banner would leave a trader looking at a book that is not theirs
// with nothing on screen saying so — and no route back, because there is no
// other exit.
//
// ⚠ It sits ABOVE the header rather than inside the scrolling content, so it is
// still there after the reader has scrolled down a 150-trade table.
// =============================================================================

export interface DemoBannerProps {
  active: boolean;
  onExit: () => void;
}

export function DemoBanner({ active, onExit }: DemoBannerProps) {
  if (!active) return null;
  return (
    <div className="demo-banner" role="status" data-testid="demo-banner">
      <span className="demo-banner-title">🎓 Demo Account</span>
      <span className="demo-banner-note">
        You’re looking at sample data. Your own trades and accounts are set aside
        and untouched — nothing here is saved.
      </span>
      <button type="button" className="btn" onClick={onExit}>Exit demo</button>
    </div>
  );
}
